import $ from 'jquery'
import Config from 'luminate/src/config'
import Base from 'luminate/src/modules/base'

export default Base.extend({
	directive: 'sticky',

	defaults: {
		name: '',
		offset: 0,
		classStuck: 'is-stuck',
		classUnstuck: 'is-unstuck'
	},

	events: {

		init: function()
		{
			const sticky = $(this.$element)
			const filler = $(`<div ${Config.directivePrefix}sticky-filler="${this.$settings.name}">`)
			const $window = $(window)
			const offset = this.$settings.offset;
			const clsStuck = this.$settings.classStuck
			const clsUnstuck = this.$settings.classUnstuck

			let isFixed = false

			sticky.before(filler)

			function fillerSize()
			{
				filler.css('height', sticky.outerHeight() + 'px')
			}

			function stickyScroll()
			{
				if(isFixed)
				{
					let fillerTop = filler.offset().top + offset

					if($window.scrollTop() <= fillerTop)
					{
						isFixed = false
						fixSticky(false)
					}
				}
				else
				{
					let stickyTop = sticky.offset().top + offset

					if($window.scrollTop() > stickyTop)
					{
						isFixed = true
						fixSticky(true)
					}
				}
			}

			function fixSticky(fix)
			{
				if(fix)
				{
					filler.css('display', '')
					sticky.addClass(clsStuck)
					sticky.removeClass(clsUnstuck)
				}
				else
				{
					filler.css('display', 'none')
					sticky.removeClass(clsStuck)
					sticky.addClass(clsUnstuck)
				}
			}

			fillerSize()
			fixSticky(false)
			stickyScroll()

			$window.on('resize', fillerSize)
			$window.on('resize scroll', stickyScroll)
		}
	}
})



// WEBPACK FOOTER //
// ./public/scripts/src/modules/sticky.js